import { useQuery } from '@tanstack/react-query';
import type { CustomSkillListItem } from '../types';

export default function useCustomSkills(companyId: string | null) {
  return useQuery<CustomSkillListItem[]>({
    queryKey: ['admin', 'companies', companyId, 'custom-skills'],
    enabled: companyId !== null,
  });
}
